<!--  -->
<template>
	<div class="container">
		<div class="search-container flex flex-between" ref="tableHeight">
			<div class="flex flex-wrap flex-1">
				<el-date-picker class="w240 mb5" format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small"
					v-model="planDate" @change="handleSearch()" type="daterange" :picker-options="pickerOptions"
					:editable="false" :clearable="false" range-separator="-" start-placeholder="开始日期"
					end-placeholder="结束日期">
				</el-date-picker>
				<el-input v-model.trim="searchFrom.orderNo" @keyup.enter.native="handleSearch" class="w190 ml10"
					size="small" placeholder="订单编号" maxlength="50" clearable>
				</el-input>
				<el-input v-model.trim="searchFrom.agentName" @keyup.enter.native="handleSearch" class="w190 ml10"
					size="small" placeholder="客商" maxlength="16" clearable>
				</el-input>
				<el-input v-model.trim="searchFrom.routeName" class="w190 ml10" size="small" placeholder="路线" maxlength="16"
					@keyup.enter.native="handleSearch" clearable>
				</el-input>
				<el-input v-model.trim="searchFrom.sapAgentNo" class="w190 ml10" size="small" placeholder="客商SAP编号"
					maxlength="30" @keyup.enter.native="handleSearch" clearable>
				</el-input>
				<el-input v-model.trim="searchFrom.ncDrawerName" class="w190 ml10 mb5" size="small" placeholder="SAP开票单位"
					maxlength="30" @keyup.enter.native="handleSearch" clearable>
				</el-input>
				<el-input v-model.trim="searchFrom.agentVoucher" class="w190 ml10" size="small" placeholder="回单编号"
					maxlength="30" @keyup.enter.native="handleSearch" clearable>
				</el-input>
				<el-select v-model="searchFrom.payType" class="w130 ml10" size="small" placeholder="付款方式" clearable
					@change="handleSearch()">
					<el-option label="现金" value="0">
					</el-option>
					<el-option label="电子" value="1">
					</el-option>
					<el-option label="账期" value="2">
					</el-option>
					<el-option label="预付款" value="3">
					</el-option>
					<el-option label="自贩" value="9">
					</el-option>
				</el-select>
				<el-select v-model="searchFrom.ncSynflag" class="w130 ml10" size="small" placeholder="SAP同步状态" clearable
					@change="handleSearch()">
					<el-option label="未同步" value="0">
					</el-option>
					<el-option label="已同步" value="1">
					</el-option>
					<el-option label="同步失败" value="2">
					</el-option>
					<el-option label="同步中" value="3">
					</el-option>
				</el-select>
				<el-select v-model="searchFrom.voucherFlag" class="w130 ml10" size="small" placeholder="店铺回单" clearable
					@change="handleSearch()">
					<el-option label="Y" value="Y">
					</el-option>
					<el-option label="N" value="N">
					</el-option>
				</el-select>
				<el-checkbox class="ml10 mt5" v-model="searchFrom.tempFlag" @change="handleSearch()">临时客商</el-checkbox>
				<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch()" alt="">
				<el-button plain class="ml10" size="small" @click="handleAttr" v-if="isEdit && roleType"
					:disabled="multipleSelection.length > 0 ? false : true">批量调整店铺回单</el-button>
			</div>
			<div v-if="isEdit && roleType" class="button-box">
				<img class="icon-img" src="@/assets/images/syn.png" @click="setSyn" title="同步" alt="">
				<img class="icon-img ml7" src="@/assets/images/delete.png" @click="deleteRow" title="删除" alt="">
				<img class="icon-img ml7" src="@/assets/images/add.png" @click="addRow" title="新增" alt="">
				<img class="icon-img ml7" src="@/assets/images/set.png" @click="setRow" title="设置" alt="">
			</div>

		</div>
		<div class="table-container">
			<div v-if="tableData.length > 0">
				<el-table ref="multipleTable" v-el-table-infinite-scroll="tableLoad" :infinite-scroll-distance="50"
					:infinite-scroll-immediate="false" :data="tableData" :height="height" :cell-style="cellStyle"
					:row-class-name="tabRowClassName"
					:header-cell-style="{ background: 'rgba(200, 204, 215,.6)', color: '#333333' }"
					:row-key="(row) => { return row.dataKey }" @selection-change="handleSelectionChange" border
					style="width: 100%" @cell-click="editRow">
					<!--  -->
					<el-table-column type="selection" width="50" :reserve-selection="true" align="center">
					</el-table-column>
					<!--  -->
					<el-table-column v-show="tableData" v-for="(value, index) in titles" :key="index" :prop="value.prop"
						:sortable="index == 8 ? false : true" :column-key="value.prop" :fixed="value.fix"
						:show-overflow-tooltip="true" :label="value.title" :min-width="value.maxWidth">
						<template slot-scope="scope">
							{{ value.title != "送货单" ? scope.row[value.prop] : "" }}
							<button v-if="value.title == '送货单' && scope.row[value.prop]" type="button" class="view-btn"
								@click="viewerHandle([scope.row[value.prop]], scope.row)">查看</button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-empty v-else :style="{ height: height + 'px' }" description="暂无数据"></el-empty>

			<div class="flex flex-between search-container">
				<div class="totalPage">
					当前第<span class="page-active">{{ currentNo }}</span>页，共<span
						class="page-active">{{ totalCount }}</span>条数据，共<span class="page-active">{{ totalPage }}</span>页
				</div>
				<div>
					<img class="icon-img ml10" style="vertical-align: middle;" src="@/assets/images/sderive.png"
						@click="storeDownload" title="出货仓导出" alt="">
					<el-upload class="ml10 inlineblock" :action="$api['orderImport'].url" :show-file-list="false"
						:before-upload="beforeAvatarUpload">
						<img class="icon-img" style="vertical-align: middle;" src="@/assets/images/simport.png"
							title="出货仓导入" alt="出货仓导入">
					</el-upload>
					<img class="icon-img ml10" style="vertical-align: middle;" src="@/assets/images/down.png"
						@click="download" title="导出" alt="">
				</div>
			</div>
		</div>
		<merchantInfo ref="merchantInfo" @getList="handleSearch"></merchantInfo>
		<merchantOrderEdit ref="merchantOrderEdit" @getList="handleSearch"></merchantOrderEdit>
		<customTable ref="customTable" @getList="handleSearch"></customTable>
		<batch ref="batch" @getList="handleSearch"></batch>
		<!-- 照片 -->
		<viewer ref="viewer" v-if="viewFlag" @closeViewer="closeViewer"></viewer>
	</div>
</template>

<script>
import merchantInfo from './components/merchant-info.vue'
import merchantOrderEdit from './components/merchant-order-edit.vue'
import customTable from './components/custom-table.vue'
import { dateFormat } from '@/utils/common'
import { dateTimeFormat } from '@/utils/common'
import { hasPermission } from '@/utils/permission'
import batch from './components/batch.vue'
import viewer from '@/components/viewer'
import {
	debounce
} from '@/utils/debounce'
export default {
	name: 'merchantOrder',
	components: {
		merchantInfo,
		merchantOrderEdit,
		customTable,
		batch,
		viewer
	},
	data() {
		return {
			searchFrom: {
				agentName: "",
				routeName: "",
				orderNo: "",
				dateEnd: "",
				dateStart: "",
				ncCode: "",
				ncDrawerName: "",
				payType: "",
				ncSynflag: "",
				voucherFlag: "",
				agentVoucher: "",
				tempFlag: null,
				sapAgentNo: ""
			},
			tableData: [],
			titles: [],
			treeData: [],
			multipleSelection: [],

			value: "",
			selectAttribute: "",
			pageNo: 1,
			pageSize: 40,
			height: 500,
			planDate: [],
			dateFormat: null,
			dateTimeFormat: null,
			infiniteFlag: false,
			isEdit: false,
			totalPage: "",
			totalCount: "",
			currentNo: "",
			roleType: window.sessionStorage.getItem("roleType") == 2 ? false : true,
			min: '',
			pickerOptions: {
				onPick: ({ minDate, maxDate }) => {
					// 将第一个选中的日期赋值给 this.min
					this.min = minDate && minDate.getTime()
					// 如果选择了时间段，则清空 this.min
					if (maxDate) {
						this.min = ''
					}
				},
				disabledDate: (time) => {
					let oneMonths = 62 * 24 * 60 * 60 * 1000
					let minDate = this.min - oneMonths
					let maxDate = this.min + oneMonths
					if (this.min !== "") {
						return time.getTime() > maxDate || time.getTime() < minDate
					}
				}
			},
			// 导入弹框控制
			visible: false,
			// 照片
			viewFlag: false,
			// 点击送货单查看按钮，当前行checkbox不被选中
			viewData: ""
		}
	},
	created() {
		const end = new Date();
		const start = new Date();
		start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
		this.planDate = [dateFormat(end), dateFormat(end)]
		this.dateFormat = dateFormat
		this.dateTimeFormat = dateTimeFormat
		this.getList()
		if (this.$route.meta.perm) {
			this.isEdit = hasPermission(this.$route.meta.perm);
		}
	},
	mounted() {
		let height = this.$refs.tableHeight.offsetHeight;
		this.height = window.innerHeight - 126 - height;
	},

	methods: {
		tabRowClassName({
			row,
			rowIndex
		}) {
			let index = rowIndex + 1;
			if (index % 2 == 1) {
				return 'warning-row'
			}
		},
		cellStyle({
			row,
			column,
			rowIndex,
			columnIndex
		}) {
			if (columnIndex == 1) {
				return 'cursor: pointer;'
			}
		},
		// 图片预览
		viewerHandle(dt, row) {
			this.viewData = row;
			this.viewFlag = true;
			this.$nextTick(() => {
				this.$refs.viewer.init(0, dt);
			})
		},
		closeViewer() {
			this.viewData = "";
			this.viewFlag = false;
		},
		// 表格滚动加载
		tableLoad: debounce(function () {
			if (this.$refs.multipleTable.bodyWrapper.scrollTop > 0) {
				this.pageNo++;
				this.getList('scroll');
			}
		}, 100, true),
		//批量sku调整属性
		handleAttr() {
			this.$refs.batch.init(this.multipleSelection)
		},
		// 搜索
		handleSearch() {
			this.infiniteFlag = false;
			this.pageNo = 1
			this.$nextTick(() => {
				this.getList()
			})
			if (this.tableData.length > 0) {
				this.$refs.multipleTable.clearSelection();
				this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
			}

		},
		// 同步Nc系统
		setSyn() {
			let that = this;
			if (that.multipleSelection.length <= 0) {
				this.$message.error('请先选择!');
				return
			}
			let agentIds = []
			that.multipleSelection.forEach(item => {
				agentIds.push(item.dataKey)
			});
			that.$confirm('是否同步选中的客商订单？', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'error'
			}).then(() => {

				that.$request.post(
					"orderSync",
					true, {
					orderIds: agentIds,
				}
				)
					.then((res) => {
						if (res) {
							that.$message.success("同步成功！");
							that.handleSearch()
						}
					})
			}).catch(() => { });
		},
		addRow() {
			this.$refs.merchantOrderEdit.init()
		},
		// 删除
		deleteRow() {
			let that = this;
			if (that.multipleSelection.length == 0) {
				that.$message.error('请先选择需要删除的数据');
				return
			}
			let orderIds = [];
			that.multipleSelection.forEach(item => {
				orderIds.push(item.dataKey);
			})
			that.$confirm('是否确认删除？', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'error'
			}).then(() => {
				that.$request.post(
					"orderDelete",
					false, {
					orderIds: orderIds,
				}
				)
					.then((res) => {
						if (res) {
							that.$message.success("删除成功");
							that.handleSearch();
						}
					})
			}).catch(() => { });
		},

		// 获取列表
		getList(type) {
			if (this.infiniteFlag) {
				return
			}
			let that = this;
			that.$request.post(
				"orderList",
				true, {
				pageNo: that.pageNo,
				pageSize: that.pageSize,
				dateStart: that.planDate ? that.planDate[0] : "",
				dateEnd: that.planDate ? that.planDate[1] : "",
				orderNo: that.searchFrom.orderNo,
				agentName: that.searchFrom.agentName,
				routeName: that.searchFrom.routeName,
				ncCode: that.searchFrom.ncCode,
				ncDrawerName: that.searchFrom.ncDrawerName,
				payType: that.searchFrom.payType,
				ncSynflag: that.searchFrom.ncSynflag,
				voucherFlag: that.searchFrom.voucherFlag,
				agentVoucher: that.searchFrom.agentVoucher,
				tempFlag: that.searchFrom.tempFlag ? 1 : "",
				sapAgentNo: that.searchFrom.sapAgentNo,
			}
			)
				.then((res) => {
					if (res.data) {
						that.infiniteFlag = res.data.totalPage <= that.pageNo;
					}
					if (type == 'scroll') {
						that.tableData = that.tableData.concat(res.data && res.data.tableDatas || []);
						that.totalPage = res.data.totalPage
						that.totalCount = res.data.totalCount
						that.currentNo = res.data.pageNo
					} else {
						if (res.data && res.data.tableDatas.length > 0) {
							that.titles = res.data.titles

							that.tableData = res.data.tableDatas
							// 对表头对应的每一列的属性进行赋值
							// 为了能正常排序 需要对所有的数值进行处理 【如果有需要数字型进行排序null或者空字付串的数值请处理为0】
							that.totalPage = res.data.totalPage
							that.totalCount = res.data.totalCount
							that.currentNo = res.data.pageNo
						} else {
							that.titles = []
							that.tableData = []
							that.totalPage = 0
							that.totalCount = 0
							that.currentNo = 0
						}

					}
					that.titles = that.titles.map((item, index) => {
						return {
							title: item.title,
							prop: 'tr' + index,
							maxWidth: item.maxWidth,
							fix: item.fix == 1 ? true : false
						}
					})
					that.tableData.forEach(item => {
						for (let i = 0; i < that.titles.length; i++) {
							item['tr' + i] = item.datas[i] || ''
						}
					})
					if (that.tableData.length > 0) {
						that.$nextTick(() => {
							that.$refs.multipleTable.doLayout(); // 解决表格错位
						});

					}

				})
		},
		// 排序列改变返回当前需要排序的列
		changeTableSort(e) {
			//获取当前列的字段
			const prop = e.prop
			// 如果按降序
			if (e.order === 'descending') {
				//根据需要对字段进行写排序
				this.tableData = this.tableData.sort((a, b) => {
					return parseFloat(a[prop]) - parseFloat(b[prop])
				})
			} else { //发果是降序
				this.tableData = this.tableData.sort((a, b) => {
					return parseFloat(b[prop]) - parseFloat(a[prop])
				})
			}
		},

		// 列多选
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		setRow() {
			this.$refs.customTable.init()
		},
		// 点击列
		// 查看/编辑
		editRow(row, column, cell, event) {
			let flag = -1
			this.titles.forEach((item, index) => {
				if (flag == -1) {
					flag = item.fix ? index : -1
				}

			});
			let index = flag == -1 ? 0 : flag
			if (column.label == this.titles[index].title) {
				this.$refs.merchantInfo.init(row)
			} else {
				if(this.viewData.dataKey == row.dataKey) {

				}else {
					this.$refs.multipleTable.toggleRowSelection(row);
				}
			}
		},
		// 出货库导出
		storeDownload() {
			let that = this;
			let orderIds = [];
			that.multipleSelection.forEach(item => {
				orderIds.push(item.dataKey);
			})
			that.$request.post(
				"orderExportDetail",
				true, {
				pageNo: 1,
				pageSize: 50000,
				orderIds: orderIds,
				dateStart: that.planDate ? that.planDate[0] : "",
				dateEnd: that.planDate ? that.planDate[1] : "",
				orderNo: that.searchFrom.orderNo,
				agentName: that.searchFrom.agentName,
				routeName: that.searchFrom.routeName,
				ncCode: that.searchFrom.ncCode,
				ncDrawerName: that.searchFrom.ncDrawerName,
				payType: that.searchFrom.payType,
				ncSynflag: that.searchFrom.ncSynflag,
				voucherFlag: that.searchFrom.voucherFlag,
				agentVoucher: that.searchFrom.agentVoucher,
				tempFlag: that.searchFrom.tempFlag ? 1 : "",
				sapAgentNo: that.searchFrom.sapAgentNo
			}
			)
				.then((res) => {
					if (res) {
						let downloadURL = res.data
						const linkNode = document.createElement('a');
						linkNode.style.display = 'none';
						linkNode.href = downloadURL;
						document.body.appendChild(linkNode);
						linkNode.click(); //模拟在按钮上的一次鼠标单击
						URL.revokeObjectURL(linkNode.href); // 释放URL 对象
						document.body.removeChild(linkNode);
					}
				})
		},
		// 导出
		download() {
			let that = this;
			// if (that.multipleSelection.length == 0) {
			// 	that.$message.error('请先选择需要导出的数据');
			// 	return
			// }
			let orderIds = [];
			that.multipleSelection.forEach(item => {
				orderIds.push(item.dataKey);
			})
			that.$request.post(
				"orderExport",
				true, {
				pageNo: 1,
				pageSize: 50000,
				orderIds: orderIds,
				dateStart: that.planDate ? that.planDate[0] : "",
				dateEnd: that.planDate ? that.planDate[1] : "",
				orderNo: that.searchFrom.orderNo,
				agentName: that.searchFrom.agentName,
				routeName: that.searchFrom.routeName,
				ncCode: that.searchFrom.ncCode,
				ncDrawerName: that.searchFrom.ncDrawerName,
				payType: that.searchFrom.payType,
				ncSynflag: that.searchFrom.ncSynflag,
				voucherFlag: that.searchFrom.voucherFlag,
				agentVoucher: that.searchFrom.agentVoucher,
				tempFlag: that.searchFrom.tempFlag ? 1 : "",
				sapAgentNo: that.searchFrom.sapAgentNo,
			}
			)
				.then((res) => {
					if (res) {
						let downloadURL = res.data
						const linkNode = document.createElement('a');
						linkNode.style.display = 'none';
						linkNode.href = downloadURL;
						document.body.appendChild(linkNode);
						linkNode.click(); //模拟在按钮上的一次鼠标单击
						URL.revokeObjectURL(linkNode.href); // 释放URL 对象
						document.body.removeChild(linkNode);
					}
				})
		},
		// 上传
		importTable(file) {
			let that = this;
			let formdata = new FormData();
			formdata.append('file', file);
			that.$request.formData(
				"orderImport",
				true,
				formdata
			)
				.then((res) => {
					if (res.data.length > 0) {
						let arr = res.data;
						let html = '<div style="height:350px;overflow: auto;">';
						for (let index = 0; index < arr.length; index++) {
							html += '<p>' + arr[index] + '</p>';
						}
						html += '</div>';
						that.$confirm(html, '提示', {
							dangerouslyUseHTMLString: true,
							showCancelButton: false,
							showConfirmButton: false,
							customClass: 'customClass'
						}).then(() => { }).catch(() => {
							that.handleSearch()
						});
					}
				})
		},
		beforeAvatarUpload(file) {
			if (file) {
				this.importTable(file)
			}
		}
	},
}

</script>

<style lang='scss' scoped>
.container {
	background: #fff;
	box-sizing: border-box;
	margin: 12px 26px 15px 10px;
	// padding-bottom: 20px;

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 0px;
		}

		/deep/ td {
			padding: 5px;
		}

		/deep/ .warning-row {
			background: #F1F1F5;
		}

		/deep/ .el-table__body-wrapper {
			height: calc(100% - 34px) !important;

		}

		/deep/ th .el-table__cell {
			padding: 0 !important;
		}

	}
}

.red {
	width: 50px;
	height: 20px;
	background: #D9001B;
}

.blue {
	width: 50px;
	height: 20px;
	background: #02A7F0;
}

.search-container {
	padding: 8px;
}

.operation-box {
	min-width: 185px;
}

.w190 {
	width: 150px !important;
}

.w130 {
	width: 130px !important;
}

.button-box {
	width: 142px !important;
}

.mb5 {
	margin-bottom: 5px;
}

.import-btn {
	color: #1bc9b5;
	background-color: rgba(27, 201, 181, 0.1);
	border: none;
	outline: none;
	padding: 10px;
	border-radius: 5px;
	margin-right: 10px;
	cursor: pointer;
}

.inlineblock {
	display: inline-block;
}

.view-btn {
	border: none;
	outline: none;
	color: #1bc9b5;
	background-color: rgba(27, 201, 181, 0.1);
	padding: 5px 10px;
	border-radius: 5px;
	cursor: pointer;
}
</style>
